export function isFolderKnownEmpty(
  hasChildren: boolean | undefined,
  visibleChildCount: number
) {
  return visibleChildCount === 0 && hasChildren === false;
}
